// import moment from 'moment';

class CollectionSheet {

    constructor(collectionSheet) {

        this.defaultValues = [];
        this.fields = {};
        this.categorized = true;
        this.period = {};
        this.initialize(collectionSheet);
    }

    initialize(collectionSheet) {

        // load data into CollectionSheet
        this.fields = collectionSheet.fields;
        this.categorized = collectionSheet.categorized;
        this.period = collectionSheet.period;

        // fill with null values by default
        this._clearValues();
    }

    newValuesToCollectionSheet(values, validFor) {
        this._clearValues();
        this.valuesToCollectionSheet(values, validFor);
        this._copyCurrentValuesToDefaultValues(values, validFor);
    }

    valuesToCollectionSheet(values, validFor, copyToDefaults = true) {

        let validValues = values;

        if (this.period.id !== 1){ // static
            // filter out measurements with wrong date (there shouldn't be any but just in case)
            validValues = validValues.filter(value => {

                if (value === null){ return false; }

                let date = new Date(value.valid_for_date);
                return date.getTime() === validFor.getTime();
            });
        }

        // replace measurementValue objects
        validValues.forEach((value) => {
            this._loopOverMeasurements((measurement) => {
                if (measurement.definition.id === value.measurement_id) {
                    measurement.value = value;
                }
            });
        });
/*
        // sort measurements by code used
        for(let keyWordIndex in this.fields){
            this.fields[keyWordIndex].measurements.sort((item1, item2) => { return (item1.definition.code > item2.definition.code); });
        }
*/
        if (copyToDefaults === true) {
            this._copyCurrentValuesToDefaultValues();
        }
    }

    getModifiedValues() {

        let modified = [];

        this.defaultValues.forEach((def) => {
            this._loopOverMeasurements((measurement) => {

                if (def.measurement_id === measurement.value.measurement_id) {
                    if (def.value != measurement.value.value) {
                        modified.push(measurement.value);
                    }
                    // if note has changed, and it is note delete value
                    else if (measurement.value.value != null && (def.note != measurement.value.note)) {
                        modified.push(measurement.value);
                    }
                }
            });
        });

        return modified;

    }

    clearErrors() {

        this._loopOverMeasurements((measurement) => {
            if (measurement.value.errors) {
                delete measurement.value.errors;
            }
        });
    }

    clearEmptyErrors() {
        this._loopOverMeasurements((measurement) => {
            if (measurement.value.errors && measurement.value.errors.length <= 0) {
                delete measurement.value.errors;
            }
        });
    }

    _loopOverMeasurements(callback) {
        Object.keys(this.fields).forEach((key) => {
            this.fields[key].measurements.forEach((meas) => { callback(meas); });
        });
    }

    _findValue(measurementValue) {

        return this._findValueByMeasurementId(measurementValue.measurement_id);
    }

    _findValueByMeasurementId(measurement_id) {

        return this._loopOverValues((measurement) => {
            if (measurement_id === measurement.value.id) {
                return measurement;
            }
        });

    }

    _getEmptyValue(measurement_id) {
        return {
            value: null,
            valid: null,
            note: null,
            measurement_id: measurement_id,
        };
    }

    _clearValues() {
        this._loopOverMeasurements((measurement) => {
            let val = this._getEmptyValue(measurement.definition.id);
            measurement.value = val;
            this.defaultValues.push(val);
        });
    }

    _copyCurrentValuesToDefaultValues() {

        this.defaultValues = [];
        this._loopOverMeasurements((measurement) => {
            this.defaultValues.push(Object.assign({}, measurement.value));
        });
    }

}

export default CollectionSheet;



// WEBPACK FOOTER //
// ./resources/assets/js/components/measurements-module/entry/CollectionSheet.js